import {Component} from '@angular/core';
import {MatCard, MatCardContent, MatCardHeader, MatCardTitle} from '@angular/material/card';

@Component({
  selector: 'app-generic-tile-list-skeleton',
  standalone: true,
  imports: [MatCardContent, MatCardTitle, MatCardHeader, MatCard],
  templateUrl: './generic-tile-list-skeleton.component.html',
  styleUrl: './generic-tile-list-skeleton.component.scss',
})
export class GenericTileListSkeletonComponent {}
